import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import AppAPI from "../api";
import AppSlice from "./reducers/appSlice";

const rootReducer = combineReducers({
  [AppSlice.name]: AppSlice.reducer,
  [AppAPI.reducerPath]: AppAPI.reducer
})

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaulMiddleware) => 
    getDefaulMiddleware()
      .concat(AppAPI.middleware)
})

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector

export default store
